import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import HeroSection from "./components/hero-section"
import EcosystemSection from "./components/ecosystem-section"
import LiveNowSection from "./components/live-now-section"
import ClosingSection from "./components/closing-section"
import Footer from "./components/footer"
import { theme } from "./theme"
import { useRef } from "react"
import MainHeader from "@/components/MainHeader"

export default function EduEcoSystem() {
  const platformRef = useRef<HTMLDivElement>(null);
  const scrollToPlatform = () => {
    platformRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MainHeader />
      <main>
        <HeroSection scrollToPlatform={scrollToPlatform} />
        <EcosystemSection platformRef={platformRef} />
        <LiveNowSection />
        <ClosingSection />
      </main>
      <Footer />
    </ThemeProvider>
  )
}
